export const DASHBOARD_FINANCING_REQUESTS = '/dashboard/financing-requests'
